import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FaireMarketIcon } from "@faire/retailer-visitor-shared/features/FaireMarkets/FaireMarketIcon";
import { bpsToPercent } from "@faire/retailer-visitor-shared/lib/bpsToDecimalAndPercent";
import { MarketStore, useMarketStore } from "@faire/retailer-visitor-shared/stores/domain/Events/FaireMarkets/MarketStore";
import { Button } from "@faire/web--source/slate/Button";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { getEventTheme } from "@faire/web--source/slate/Theme/eventsThemeColors";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled from "styled-components";
export var BrandsLandingPageFaireMarket = function(param) {
    var onClick = param.onClick;
    var isMobile = useViewport().isMobile;
    var marketName = useMarketStore([
        "marketName"
    ]).marketName;
    var latestMarketEarlyAccessRangeDate = useMarketStore([
        "latestMarketEarlyAccessRangeDate"
    ]).latestMarketEarlyAccessRangeDate;
    var ValuePropContainer = isMobile ? Column : ValuePropContainerRow;
    var valuePropFontVariant = isMobile ? "paragraphSansMedium" : "subheadingSansMedium";
    return /*#__PURE__*/ _jsx(Container, {
        children: /*#__PURE__*/ _jsxs(ContentContainer, {
            children: [
                /*#__PURE__*/ _jsxs(Row, {
                    children: [
                        /*#__PURE__*/ _jsx(SectionTitle, {
                            variant: isMobile ? "pageHeaderSerifRegular" : "displayMSerifRegular",
                            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                id: "IEk1hI",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Join to sell at "
                                    },
                                    {
                                        type: 1,
                                        value: "marketEventName"
                                    },
                                    {
                                        type: 0,
                                        value: ", happening "
                                    },
                                    {
                                        type: 1,
                                        value: "eventRangeDate"
                                    }
                                ],
                                values: {
                                    marketEventName: marketName,
                                    eventRangeDate: latestMarketEarlyAccessRangeDate
                                }
                            })
                        }),
                        isMobile ? /*#__PURE__*/ _jsx(MobileMarketIcon, {}) : /*#__PURE__*/ _jsx(MarketIcon, {})
                    ]
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "4x"
                }),
                /*#__PURE__*/ _jsxs(ValuePropContainer, {
                    children: [
                        /*#__PURE__*/ _jsxs(ValuePropColumn, {
                            children: [
                                /*#__PURE__*/ _jsx(ValuePropTypography, {
                                    variant: valuePropFontVariant,
                                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                        id: "YcAi6e",
                                        defaultMessage: [
                                            {
                                                type: 0,
                                                value: "Drive a season's worth of sales in just a few days"
                                            }
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Spacer, {
                                    height: "1x"
                                }),
                                /*#__PURE__*/ _jsx(ValuePropTypography, {
                                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                        id: "UoAPfa",
                                        defaultMessage: [
                                            {
                                                type: 0,
                                                value: "Retailers love shopping Faire Markets to discover new brands at great prices. Join for your chance to connect with more buyers than any other time of the year."
                                            }
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Spacer, {
                            width: "3x"
                        }),
                        /*#__PURE__*/ _jsxs(ValuePropColumn, {
                            children: [
                                /*#__PURE__*/ _jsx(ValuePropTypography, {
                                    variant: valuePropFontVariant,
                                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                        id: "M8R0QG",
                                        defaultMessage: [
                                            {
                                                type: 0,
                                                value: "Offer your retailers the best prices\u2014on us"
                                            }
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Spacer, {
                                    height: "1x"
                                }),
                                /*#__PURE__*/ _jsx(ValuePropTypography, {
                                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                        id: "0mZKRT",
                                        defaultMessage: [
                                            {
                                                type: 0,
                                                value: "Faire will be offering our popular discount matching program for brands\u2014up to "
                                            },
                                            {
                                                type: 1,
                                                value: "discountAmountNumber"
                                            },
                                            {
                                                type: 0,
                                                value: "% off all orders."
                                            }
                                        ],
                                        values: {
                                            discountAmountNumber: bpsToPercent(MarketStore.get().matchedDiscountCapBps)
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Spacer, {
                            width: "3x"
                        }),
                        /*#__PURE__*/ _jsxs(ValuePropColumn, {
                            children: [
                                /*#__PURE__*/ _jsx(ValuePropTypography, {
                                    variant: valuePropFontVariant,
                                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                        id: "FOFLJB",
                                        defaultMessage: [
                                            {
                                                type: 0,
                                                value: "It\u2019s free and convenient to participate"
                                            }
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Spacer, {
                                    height: "1x"
                                }),
                                /*#__PURE__*/ _jsx(ValuePropTypography, {
                                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                        id: "AefNu1",
                                        defaultMessage: [
                                            {
                                                type: 0,
                                                value: "There\u2019s no need to step away from your day-to-day business to attend. To participate, simply sign up for Faire and set up a market promotion."
                                            }
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "5x"
                }),
                /*#__PURE__*/ _jsx(CtaButton, {
                    variant: "secondary",
                    onClick: onClick,
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "cXRNeT",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Join Faire"
                            }
                        ]
                    })
                })
            ]
        })
    });
};
var Container = styled(Row).attrs({
    justify: "center"
}).withConfig({
    componentId: "sc-9536b106-0"
})([
    "background-color:",
    ";",
    "{padding:",
    ";}",
    "{padding:",
    ";}"
], getEventTheme("faireMarket").primaryDark, responsiveMediaQueries.tabletAndAbove, getSpacing("10x"), responsiveMediaQueries.mobile, getSpacing("3x"));
var ContentContainer = styled(Column).withConfig({
    componentId: "sc-9536b106-1"
})([
    "",
    "{width:900px;}",
    "{width:100%;}"
], responsiveMediaQueries.tabletAndAbove, responsiveMediaQueries.mobile);
var CtaButton = styled(Button).withConfig({
    componentId: "sc-9536b106-2"
})([
    "width:100%;border:unset;",
    "{width:278px;}"
], responsiveMediaQueries.tabletAndAbove);
var MarketIcon = styled(FaireMarketIcon).attrs({
    size: "124px",
    color: getEventTheme("faireMarket").secondary
}).withConfig({
    componentId: "sc-9536b106-3"
})([
    "position:absolute;right:0;"
]);
var MobileMarketIcon = styled(FaireMarketIcon).attrs({
    color: getEventTheme("faireMarket").secondary,
    size: "89px"
}).withConfig({
    componentId: "sc-9536b106-4"
})([
    "position:absolute;right:-32px;"
]);
var SectionTitle = styled(Typography).attrs({
    color: getEventTheme("faireMarket").promoTextInverse
}).withConfig({
    componentId: "sc-9536b106-5"
})([
    "&&&{max-width:850px;",
    "{margin-right:72px;}}"
], responsiveMediaQueries.tabletAndBelow);
var ValuePropColumn = styled(Column).withConfig({
    componentId: "sc-9536b106-6"
})([
    ""
]);
var ValuePropContainerRow = styled(Row).attrs({
    justify: "space-between"
}).withConfig({
    componentId: "sc-9536b106-7"
})([
    ""
]);
var ValuePropTypography = styled(Typography).attrs({
    color: getEventTheme("faireMarket").promoTextInverse
}).withConfig({
    componentId: "sc-9536b106-8"
})([
    ""
]);
